import React, { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Accordion, Button, Form } from 'react-bootstrap';
import Pergunta from './pergunta';
import '../../styles/itens.scss';
import { Link } from 'react-router-dom';

async function getItens() {
    let response = await fetch('https://prefeituramacuco.rj.gov.br/transparencia/api/perguntas.json');
    let data = await response.json();
    return data;
}

const Perguntas = () => {
    const [itens, setItens] = useState([]);
    const [termoBusca, setTermoBusca] = useState('');
    const [categoriaSelecionada, setCategoriaSelecionada] = useState('');
    const [secretariaSelecionada, setSecretariaSelecionada] = useState('');

    // Filtros únicos
    const [categorias, setCategorias] = useState([]);
    const [secretarias, setSecretarias] = useState([]);

    useEffect(() => {
        getItens().then(data => {
            const perguntas = data['perguntas'];
            setItens(perguntas);

            // Extrair valores únicos de categoria e secretaria
            const categoriasUnicas = [...new Set(perguntas.map(item => item.categoria).filter(Boolean))];
            const secretariasUnicas = [...new Set(perguntas.map(item => item.secretaria).filter(Boolean))];

            setCategorias(categoriasUnicas);
            setSecretarias(secretariasUnicas);
        });
    }, []);

    // Aplicar filtros
    const itensFiltrados = itens.filter(item => {
        const buscaTexto = termoBusca.toLowerCase();
        const emTitulo = item.titulo.toLowerCase().includes(buscaTexto);
        const emDescricao = item.descricao.toLowerCase().includes(buscaTexto);

        const categoriaOk = !categoriaSelecionada || item.categoria === categoriaSelecionada;
        const secretariaOk = !secretariaSelecionada || item.secretaria === secretariaSelecionada;

        return (emTitulo || emDescricao) && categoriaOk && secretariaOk;
    });

    return (
        <Fragment>
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'><Button variant='danger'>Voltar</Button></Link>
                    </Col>
                </Row>

                <br />

                <Row className="mb-4">
                    <Col md={4}>
                        <Form.Control
                            type="text"
                            placeholder="Buscar por título ou descrição"
                            value={termoBusca}
                            onChange={(e) => setTermoBusca(e.target.value)}
                        />
                    </Col>
                    <Col md={4}>
                        <Form.Select value={categoriaSelecionada} onChange={(e) => setCategoriaSelecionada(e.target.value)}>
                            <option value="">Todas as categorias</option>
                            {categorias.map((cat, index) => (
                                <option key={index} value={cat}>{cat}</option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col md={4}>
                        <Form.Select value={secretariaSelecionada} onChange={(e) => setSecretariaSelecionada(e.target.value)}>
                            <option value="">Todas as secretarias</option>
                            {secretarias.map((sec, index) => (
                                <option key={index} value={sec}>{sec}</option>
                            ))}
                        </Form.Select>
                    </Col>
                </Row>

                <Row xs={1}>
                    {itensFiltrados.length > 0 ? (
                        itensFiltrados.map((item, index) => (
                            <Col key={index}>
                                <Accordion>
                                    <Pergunta
                                        titulo={item.titulo}
                                        descricao={item.descricao}
                                        categoria={item.categoria}
                                    />
                                </Accordion>
                            </Col>
                        ))
                    ) : (
                        <Col>
                            <p>Nenhum resultado encontrado.</p>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default Perguntas;
